import * as React from 'react'

import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { billingRoutesMap } from './routes'

type Props = {
  children: React.ReactNode
  companyId: string
}

export const BillingLayout = ({ children, companyId }: Props) => {
  const { t } = useLocalize()
  const perCompanyPath = billingRoutesMap.perCompany.replace(
    ':companyId',
    companyId,
  )

  return (
    <div className="module-billing tw-padding-4 tw-m-1 tw-flex tw-min-w-[900px] tw-flex-[1] tw-flex-col tw-max-h-[calc(100vh-8px)] tw-overflow-y-hidden tw-rounded-xl tw-border tw-border-base-300 tw-bg-base-100 tw-text-content-base">
      {/* <nav className="tw-flex tw-flex-wrap tw-border-b tw-border-base-300 tw-px-4">
        <NavLink
          exact
          to={perCompanyPath}
          className="tw-border-b-2 tw-border-transparent tw-px-4 tw-py-3 tw-text-sm tw-font-medium tw-text-content-base hover:tw-text-primary"
          activeClassName="tw-border-primary tw-text-primary"
        >
          {t('billing.tab.perCompany')}
        </NavLink>
      </nav> */}
      <div className="tw-flex tw-min-h-0 tw-flex-1 tw-flex-col">{children}</div>
    </div>
  )
}
